import React, { useEffect, useState } from 'react';
import { GridComponent, ColumnsDirective, ColumnDirective } from '@syncfusion/ej2-react-grids';
import { Box, Typography } from '@material-ui/core';
import { chipperLoaderColumnData } from '../Data/ColumnData';
import { Button } from '@mui/material';

function camelCaseToLabel(text) {
  return text.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
}

const SyncFusionChipper = ({
  data,
  sectionName,
  columns: externalColumns,
  minWidth = '1200px',
  handleChipperEdit,
  handleChipperDocs,
  chipperMainData,
  headerUI,
}) => {
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    setTableData(data || []);
  }, [data]);

  const columns = externalColumns || chipperLoaderColumnData?.[sectionName] || [];

  const handleDoubleClick = args => {
    if (handleChipperEdit) {
      handleChipperEdit(sectionName, args.rowData);
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      {/* HEADER */}
      <Typography variant="h5" style={{ paddingBottom: 8 }}>
        {camelCaseToLabel(sectionName)} {headerUI || ''}
      </Typography>

      <div style={{ overflow: 'auto', width: '100%' }}>
        <GridComponent
          dataSource={tableData}
          allowTextWrap={true}
          recordDoubleClick={handleDoubleClick}
          style={{ minWidth }}>
          <ColumnsDirective>
            {columns.map((col, index) => {
              const commonProps = {
                field: col.key,
                headerText: col.label,
                width: col.width || 'auto',
                key: `${col.key}_${index}`,
              };

              // formatter support
              if (col.formatter) {
                return (
                  <ColumnDirective {...commonProps} valueAccessor={(field, data) => col.formatter(data?.[col.key], data)} />
                );
              }

              if (col.isDocument) {
                return (
                  <ColumnDirective
                    key={col.key}
                    field={col.key}
                    headerText={col.label}
                    width={col.width || 120}
                    template={props => (
                      <Button size="small" variant="text" onClick={() => handleChipperDocs(props)}>
                        View Docs
                      </Button>
                    )}
                  />
                );
              }

              return <ColumnDirective {...commonProps} />;
            })}
          </ColumnsDirective>
        </GridComponent>
      </div>
    </Box>
  );
};

export default SyncFusionChipper;
